import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIGameBaseTileController} from './UIGameTileControllerBase'
import {UIGameManager} from '../UIGameManager'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {FogTileGroupStates} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {TileHex} from '@colonist/game-mechanic-validators'

export class UIGameFogTileController extends UIGameBaseTileController implements UIGameMechanic {
    private readonly fogTileGroupStates: FogTileGroupStates
    private readonly fogTiles: TileHex[]

    constructor(uiGameManager: UIGameManager, fogTileGroupStates: FogTileGroupStates) {
        super(uiGameManager)
        this.fogTileGroupStates = fogTileGroupStates

        this.fogTiles = this.getFogTiles()

        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MapStateUpdated: this.updateFogTiles(); break
            default: break
        }
    }

    private getFogTiles(): TileHex[] {
        const fogTiles: TileHex[] = []
        for(const fogTileGroupKey in this.fogTileGroupStates) {
            const fogTileGroup = this.fogTileGroupStates[fogTileGroupKey]
            if(fogTileGroup == undefined) continue

            for(const fogTileIndex of fogTileGroup.fogTileIndexes) {
                const tile = this.uiGameManager.gameController.mapValidator.tileState.tiles[fogTileIndex]
                const tileClone = new TileHex({
                    x: tile.hexFace.x,
                    y: tile.hexFace.y,
                    type: tile.tileType,
                    diceNumber: tile.diceNumber,
                })

                fogTiles.push(tileClone)
            }
        }

        return fogTiles
    }

    private updateFogTiles() {
        for(const tile of this.fogTiles) {
            const currentTile = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(tile.hexFace)
            if(currentTile == undefined) continue
            if(currentTile.tileType == tile.tileType) continue

            tile.state.type = currentTile.tileType
            this.updateTileTexture(tile)

            this.uiGameManager.mapController.mapView.sortChildren()
        }
    }

    private updateTileTexture(tile: TileHex) {
        const newTexture = UIGameSpriteHandler.getHexImage(tile.tileType)
        if(newTexture == undefined) return
        for(const tileView of this.uiGameManager.mapController.tileViews) {
            if(!tile.hexFace.sameFace(tileView.hexFace)) continue
            tileView.tileSpriteView.texture = newTexture
        }
    }
}
